//import './internal/bx';

import Type from '../../src/lib/type';
import Reflection from '../../src/lib/reflection';
import Text from '../../src/lib/text';
import Dom from '../../src/lib/dom';
import Browser from '../../src/lib/browser';
import Event from '../../src/lib/event';
import Http from '../../src/lib/http';
import Runtime from '../../src/lib/runtime';
import Loc from '../../src/lib/loc';
import Tag from '../../src/lib/tag';
import Uri from '../../src/lib/uri';
import Validation from '../../src/lib/validation';
import Cache from '../../src/lib/cache';
import BaseError from '../../src/lib/base-error';
import ZIndexManager from '../../src/lib/z-index/z-index-manager';
import Extension from '../../src/lib/extension/extension';

export {
	Type,
	Reflection,
	Text,
	Dom,
	Browser,
	Event,
	Http,
	Runtime,
	Loc,
	Tag,
	Uri,
	Validation,
	Cache,
	BaseError,
	ZIndexManager,
	Extension,
};

export * from '../../src/core-compatibility';